module.exports = __webpack_public_path__ + "static/media/kitchen.c3c626a3.svg";